/**
 *
 * Organizations/Show/OptIns/Show
 *
 */

import React, { useState } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Components
import Form from '../Form'

// Utils
import { generateOptions } from '..'

const OptInContainer = styled.div`
	position: relative;
	&:hover {
		.opt_in_action_buttons {
			opacity: 1;
		}
	}
`

function Show({ opt_in, organization, handleClose }) {
	const options = generateOptions(opt_in)
	const [edit, setEdit] = useState(!opt_in.id)

	const selected_option = options.find((option) => option.value === organization.opt_in_default_behaviors[opt_in.id])

	if (!opt_in.global_default && edit) return <Form opt_in={opt_in} handleClose={handleClose} />

	return (
		<OptInContainer>
			{!opt_in.global_default && (
				<FontAwesomeIcon
					onClick={() => setEdit(true)}
					icon="pencil"
					className="text-warning clickable float-right"
					size="lg"
				/>
			)}

			<div>
				<div className="pb-2">
					<h5>
						<strong>{opt_in.name}</strong>
					</h5>
					<div>{opt_in.text}</div>
				</div>

				<div className="border-top pt-2 mt-1">
					<p className="mr-2 mb-1">
						If a contact does <em>not</em> accept the opt-in:
					</p>
					<p className="mr-2 mb-0">
						<b>{selected_option?.text}</b>
					</p>
				</div>
			</div>
		</OptInContainer>
	)
}

Show.propTypes = {
	organization: PropTypes.object,
	opt_in: PropTypes.object,
	handleClose: PropTypes.func,
}

export default Show
